import React from 'react';

import { feedbackMessages } from '../../../translates/feedbackMessages';
import { generalMessages } from '../../../translates/generalMessages';
import { useIntlReexport } from '../../hooks/useIntlReexport';
import { OverlayConfirmation } from '../shared/OverlayConfirmation';
import { ButtonVariant } from '@ael/shared-components-library';

interface ClientEmailConfirmationProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const ClientEmailConfirmation: React.FC<ClientEmailConfirmationProps> = ({ onCancel, onConfirm }) => {
  const { formatMessage } = useIntlReexport();
  return (
    <OverlayConfirmation
      header={formatMessage(feedbackMessages.clientConfirmHeader)}
      text={formatMessage(feedbackMessages.clientConfirmMessage)}
      buttonLabel={formatMessage(generalMessages.yes)}
      buttonColor={ButtonVariant.BLUE}
      onCancel={onCancel}
      onClick={onConfirm}
    />
  );
};
